import ImageUploadDrag from '../../src/legacy/ImageUploadDrag';
export default ImageUploadDrag;
